import { styled } from 'baseui'
import type { Theme } from 'baseui'

import { pulseLighting } from '@/shared/theme/pulseLighting'

export type PollFootnoteTone = 'muted' | 'danger'

export const PollFormColumn = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.625rem',
})

export const PollFaces = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.5rem',
})

export const CommentLabel = styled('label', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
  fontSize: '0.75rem',
  fontWeight: 600,
  color: $theme.colors.textPulseLabel,
}))

export const OptionalMark = styled('span', ({ $theme }) => ({
  fontWeight: 400,
  color: $theme.colors.textPulseMuted,
}))

export const PollFootnote = styled<'span', { $tone: PollFootnoteTone }>('span', ({ $theme, $tone }) => ({
  fontSize: '0.6875rem',
  lineHeight: '1rem',
  color: $tone === 'danger' ? $theme.colors.dangerPulseText : $theme.colors.textPulseMuted,
}))

const fieldBorder = (color: string) => ({
  borderTopColor: color,
  borderBottomColor: color,
  borderLeftColor: color,
  borderRightColor: color,
})

export const PollCommentOverrides = {
  Root: {
    style: ({ $theme, $isFocused }: { $theme: Theme; $isFocused: boolean }) => ({
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      borderBottomLeftRadius: '8px',
      borderBottomRightRadius: '8px',
      backgroundColor: $theme.colors.white,
      boxShadow: $isFocused ? pulseLighting($theme).shadowPulseFocus : 'none',
      ...fieldBorder($isFocused ? $theme.colors.borderPulseControl : $theme.colors.borderPulseCard),
    }),
  },
  InputContainer: {
    style: ({ $theme }: { $theme: Theme }) => ({ backgroundColor: $theme.colors.white }),
  },
  Input: {
    style: ({ $theme }: { $theme: Theme }) => ({
      minHeight: '3.5rem',
      paddingTop: '0.5rem',
      paddingBottom: '0.5rem',
      paddingLeft: '0.625rem',
      paddingRight: '0.625rem',
      fontSize: '0.8125rem',
      lineHeight: '1.4',
      color: $theme.colors.textPulseStrong,
      backgroundColor: $theme.colors.white,
      resize: 'vertical' as const,
    }),
  },
}
